import {Box, Button, Collapse, Stack} from '@mui/material';
import React, {useState} from 'react';

import {translations} from 'presentation/translations-new';
import {useGetSolusPortal} from 'presentation/hooks/useGetSolusPortal';
import {AlertInfo} from '../AlertInfo';
import {PageAlertProps} from './types';
import {PageAlertVariantEnum} from './constants';

const {ndiAlert} = translations['pt-br'].privateFlow.myFinancial.incomeTax;
const {readMore, readLess} = translations['pt-br'].commons;

function AlertNdi({
	message,
	variant = PageAlertVariantEnum.NORMAL,
	hideAction,
	buttonTitle = ndiAlert.button,
	title,
	onClick,
	description,
	marginBottom = '32px',
	dataTagId,
	removeButtonIcon = false,
}: PageAlertProps) {
	const {openLink} = useGetSolusPortal();
	const [expandedState, setExpandedState] = useState(false);
	const isCollapsed = variant === 'collapsed';

	const handleExpandClick = () => {
		setExpandedState(prev => !prev);
	};

	return (
		<AlertInfo.Root sx={{mb: marginBottom}}>
			{title ? <AlertInfo.Title title={title} /> : null}
			<AlertInfo.Description>{message}</AlertInfo.Description>
			{isCollapsed ? (
				<Collapse in={expandedState}>
					<Stack gap={2} mt={2}>
						{expandedState && description}
					</Stack>
				</Collapse>
			) : null}
			{hideAction ? null : (
				<Stack>
					{isCollapsed ? (
						<Box display="flex" justifyContent="flex-end" mt={1}>
							<Button size="small" onClick={handleExpandClick} variant="text">
								{expandedState ? `${readLess}` : `${readMore}`}
							</Button>
						</Box>
					) : (
						<AlertInfo.Action
							data-tag-id={dataTagId}
							$iconName={removeButtonIcon ? undefined : 'external-link-default'}
							onClick={onClick || openLink}>
							{buttonTitle}
						</AlertInfo.Action>
					)}
				</Stack>
			)}
		</AlertInfo.Root>
	);
}

export {AlertNdi};
